let deferredPromptEvent = null;
const listeners = new Set();

function notify(event) {
  listeners.forEach((listener) => {
    listener(event);
  });
}

if (typeof window !== 'undefined') {
  window.addEventListener('beforeinstallprompt', (event) => {
    event.preventDefault();
    deferredPromptEvent = event;
    notify(event);
  });

  window.addEventListener('appinstalled', () => {
    deferredPromptEvent = null;
    notify(null);
  });
}

export function getDeferredInstallPrompt() {
  return deferredPromptEvent;
}

export function subscribeInstallPrompt(listener) {
  listeners.add(listener);
  if (deferredPromptEvent) {
    listener(deferredPromptEvent);
  }
  return () => {
    listeners.delete(listener);
  };
}

export function clearDeferredInstallPrompt() {
  deferredPromptEvent = null;
  notify(null);
}
